import { isEnvironmentProduction } from './services/utils';
// URLS SHOULD NEVER END IN /.


// REACT_APP_NODE_ENV is injected into .env in Jenkins.
export const GET_SYSTEM_PROFILE_URL = () => {
    if (isEnvironmentProduction()) {
        return 'https://users.livemarketdata.com/v3/token/system_profile';
    } else {
        return 'https://users-staging.livemarketdata.com/v3/token/system_profile';
    }
}

export const GET_NEW_TOKEN_URL = () => {
    if (isEnvironmentProduction()) {
        return 'https://users.livemarketdata.com/v3/token/create';
    } else {
        return 'https://users-staging.livemarketdata.com/v3/token/create';
    }
}

export const GET_REQUEST_TOKEN_URL = () => {
    if (isEnvironmentProduction()) {
        return 'https://users.livemarketdata.com/v3/refresh_token/create';
    } else {
        return 'https://users-staging.livemarketdata.com/v3/refresh_token/create';
    }
}

export const GET_VALIDATE_REFRESH_URL = () => {
    if (isEnvironmentProduction()) {
        return 'https://users.livemarketdata.com/v3/refresh_token/validate';
    } else {
        return 'https://users-staging.livemarketdata.com/v3/refresh_token/validate';
    }
}

export const GET_USER_INFO_URL = () => {
    if (isEnvironmentProduction()) {
        return 'https://users.livemarketdata.com/v3/token/user_info';
    } else {
        return 'https://users-staging.livemarketdata.com/v3/token/user_info';
    }
}

export const GET_AUTOCOMPLETE_STOCKS_URL = () => {
    return 'https://api.livemarketdata.com/v1/static_data/v1/autocomplete/shares?exchange=XICE';
}

export const GET_API_LMD_URL = () => {
    if (isEnvironmentProduction()) {
        return 'https://api.livemarketdata.com';
    } else {
        return 'https://api-staging.livemarketdata.com';
    }
}

export const GET_SIGTI_API_URL = () => {
    // return 'http://localhost:8000/graphql'
    if (isEnvironmentProduction()) {
        return 'https://sigti-api.livemarketdata.com/graphql';
    } else {
        return 'https://sigti-api-staging.livemarketdata.com/graphql';
    }
}

export const GET_NEWS_API_URL = (symbol: string, fromDate: string, toDate: string) => {
    if (isEnvironmentProduction()) {
        return `https://news.livemarketdata.com/newsgateway/search/news?f=symbol.sourceTicker;symbol.ticker&isSimple=false&limit=100&maxAge=100y&q=${symbol}_OMX_IS&start=0&dateFrom=${new Date(fromDate).toISOString()}&dateTo=${new Date(toDate).toISOString()}`;
    } else {
        return `https://news-staging.livemarketdata.com/newsgateway/search/news?f=symbol.sourceTicker;symbol.ticker&isSimple=false&limit=100&maxAge=100y&q=${symbol}_OMX_IS&start=0&dateFrom=${new Date(fromDate).toISOString()}&dateTo=${new Date(toDate).toISOString()}`;
    }
}

//////////////////////////////////////////////////

let _AUTOCOMPLETE_EXTRAS;
try {
    _AUTOCOMPLETE_EXTRAS = JSON.parse(process.env.AUTOCOMPLETE_EXTRAS || '');
} catch (e) {
    _AUTOCOMPLETE_EXTRAS = { "bonds": [], "shares": [["OSSR", "Össur hf."], ["ARION SDB", "Arion banki hf SDB"]] }
}

export const AUTOCOMPLETE_EXTRAS = _AUTOCOMPLETE_EXTRAS;